<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-edit :width="22" :height="22" />추가 옵션을 입력해주세요.
      </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <!-- 근태/보상휴가  -->
      <vacation-options
        v-if="isVacation || isReward || isCancelVacation || isCancelReward"
      />
      <!-- 연장근무 -->
      <ot-work-options v-if="isOtWork" />
      <!-- 근무스케줄 -->
      <schedule-options v-if="isSchedule" />
      <!-- 출퇴근변경신청 -->
      <attend-options v-if="isAttend" />

      <!-- 비고 -->
      <v-row class="ma-0">
        <v-col cols="12" class="py-5 px-6 bt-line borderLine-outer mb-0">
          <div class="borderLine-wrap" @click="bottomSelect = !bottomSelect">
            <span class="borderLine-title">비고</span>
            <v-btn
              elevation="0"
              text
              fab
              width="24"
              height="24"
              class="ml-auto"
            >
              <v-icon size="24" color="#9ca3ab">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
          <div class="py-3">
            <span v-if="reasonFlag === 'F'" class="place-holder"
              >비고를 선택해주세요</span
            >
            <!-- 퍼블리싱 필요 -->
            <v-textarea
              v-else
              v-model="reason"
              label="비고를 입력하세요"
              hide-details=""
              dense
              solo
              class="shadow-none px-0"
              :height="keybordUp ? '300px' : '48px'"
            />
          </div>
        </v-col>
      </v-row>
      <!-- 첨부파일 -->
      <attach-file-add />

      <!-- 비고 선택 목록-->
<!--      <bottom-select-->
<!--        :flag="bottomSelect"-->
<!--        :list="reasonList"-->
<!--        :title="selecttitle"-->
<!--        @selectItem="selectReason"-->
<!--      />-->
      <v-bottom-sheet v-if="bottomSelect" v-model="bottomSelect">
        <bottom-sheet :title="selecttitle" :default="selectedReason" :items="reasonList" @selectItem="selectReason"></bottom-sheet>
      </v-bottom-sheet>
      <!-- 다음버튼 -->
      <next-btn v-if="!keybordUp" @next="nextStep()" />
    </div>
  </div>
</template>
<script>
import IconEdit from '@/assets/customIcon/IconEdit.vue';
import VacationOptions from '@/components/application/extraOptions/VacationOptions.vue';
import OtWorkOptions from '@/components/application/extraOptions/OtWorkOptions.vue';
import ScheduleOptions from '@/components/application/extraOptions/ScheduleOptions.vue';
import AttendOptions from '@/components/application/extraOptions/AttendOptions.vue';

import NextBtn from '@/components/application/buttons/AppNextBtn.vue';
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import AttachFileAdd from '@/components/application/form/AttachFileAdd.vue';
import applCdMixin from '@/mixins/applCdMixin.js';
import routerNames from '@/const/routerConstants';

import { mapGetters, mapMutations } from 'vuex';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  mixins: [applCdMixin],
  data: () => ({
    bottomSelect: false,
    keybordUp: false,
    selecttitle: '비고',
    reasonList: [
      { codeNm: '개인사유', code: 'T' },
      { codeNm: '병원진료', code: 'T' },
      { codeNm: '건강검진', code: 'T' },
      { codeNm: '직접입력', code: 'I' },
    ],
    chips: [],
    selectedReason : ''
  }),
  watch: {},
  computed: {
    ...mapGetters('ELA', [
      'GET_UI_INFO',
      'GET_FILE_ID',
      'GET_REASON_FLAG',
      'GET_REASON',
    ]),
    reason: {
      get() {
        return this.GET_REASON;
      },
      set(data) {
        this.SET_REASON(data);
      },
    },
    reasonFlag: {
      get() {
        return this.GET_REASON_FLAG === '' ? 'F' : this.GET_REASON_FLAG;
      },
      set(data) {
        this.SET_REASON_FLAG(data);
      },
    },
  },

  methods: {
    ...mapMutations('ELA', ['SET_REASON', 'SET_REASON_FLAG']),

    /* 비고 목록 노출 */
    selectReason(item) {
      this.SET_REASON_FLAG(item.code);
      this.SET_REASON(item.code === 'I' ? '' : item.codeNm);
      this.selectedReason = item.code;
      this.bottomSelect = !this.bottomSelect;
    },

    /* 다음 */
    nextStep() {
      // 파일첨부 필수 여부
      if (
        this.GET_UI_INFO.fileYn === 'Y' &&
        this.GET_UI_INFO.fileEssentialYn === 'Y' &&
        this.GET_FILE_ID === ''
      ) {
        alert('파일 첨부가 필요한 신청서입니다.');
        return false;
      }

      // 사유 필수 여부
      if (
        this.isOtWork ||
        this.isAttend ||
        this.isCancelVacation ||
        this.isCancelReward ||
        this.isVacation
      ) {
        if (
          (this.reasonFlag === 'I' && this.reason === '') ||
          this.reasonFlag === 'F'
        ) {
          alert('비고는 필수 입력사항입니다.');
          return false;
        }
      }

      this.$router.push(routerNames.ApprovalLine);
    },

    /* 모바일 키보드 올라오면 BottomBtn 비활성화 */
    handleResize() {
      this.keybordUp = !this.keybordUp;
    },
  },
  created() {
    this.keybordUp = false;
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  components: {
    BottomSheet,
    IconEdit,
    VacationOptions,
    NextBtn,
    BottomSelect,
    AttachFileAdd,
    OtWorkOptions,
    ScheduleOptions,
    AttendOptions,
  },
};
</script>
<style>
/* _approval.scss 에 넣음 */
</style>
